import { useTheme } from "next-themes";
import { cn } from "@/shared/lib/utils";
import fpIconColor from "@/assets/fp-icon-color.png";
import fpIconWhite from "@/assets/fp-icon-white.png";

type BrandIconProps = {
  className?: string;
  alt?: string;
};

export function BrandIcon({ className, alt = "Factory Pilot" }: BrandIconProps) {
  const { resolvedTheme } = useTheme();
  const iconSrc = resolvedTheme === "dark" ? fpIconWhite : fpIconColor;

  return <img src={iconSrc} alt={alt} className={cn("h-8 w-8", className)} />;
}
